module.exports = __webpack_public_path__ + "media/images/new_home/icon-2-c2d3edb869651adf7bd40d61b359adb1.png";